import script from "./system-default-registry-pull-secrets.vue?vue&type=script&setup=true&lang=ts"
export * from "./system-default-registry-pull-secrets.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__